var childrenRootLegacy = 'scrollAreaLegacy_childrenRootLegacy__1fza2i10';
var scrollAreaRootLegacy = 'scrollAreaLegacy_scrollAreaRootLegacy__1fza2i11';
var scrollAreaViewportLegacy = 'scrollAreaLegacy_scrollAreaViewportLegacy__1fza2i15';
var scrollAreaViewportLegacyPaddingBottom = 'var(--scroll-area-viewport-legacy-padding-bottom__1fza2i14)';
var scrollAreaViewportLegacyPaddingTop = 'var(--scroll-area-viewport-legacy-padding-top__1fza2i13)';
var scrollbarMarginTop = 'var(--scrollbar-margin-top__1fza2i12)';

export { childrenRootLegacy, scrollAreaRootLegacy, scrollAreaViewportLegacy, scrollAreaViewportLegacyPaddingBottom, scrollAreaViewportLegacyPaddingTop, scrollbarMarginTop };
//# sourceMappingURL=scrollAreaLegacy.vanilla.mjs.map
